<template>

    <!--================ Head Menu Area =================-->

    <div></div>

    <!--================ //Head Menu Area =================-->

</template>

<script>

    // import
    import { mapGetters } from "vuex";
    import { mapActions } from "vuex";

    // export
    export default {

        computed: {

            ...mapGetters({
                getBase: "getBase"
            }),

        },

        data() {
            return {
                gubunPage: "INC USER HEAD"
            };
        },

        methods: {

            ...mapActions({
                setBase: "setBase"
            })

            // 진입점
            , default() {

                // this
                let _this = this;

                // 시작
                _this.exec("INIT"); 
            }

            // 실행
            , exec: function (gubun) {

                // this
                let _this = this;
                let url = "";
                let data = { "gubunProc": gubun, "gubunPage": _this.gubunPage };

                switch (gubun) {

                    case "INIT":
                        {
                            // 1. dimm 보이기
                            _this.$ShowDimmLogo();

                            // 2. 현재 경로 & 쿼리스트링
                            {
                                /*
                                window.location.hostname;   // => kftc.local
                                window.location.href;       // => http://kftc.local:8088/test.jsp
                                window.location.host;       // => kftc.local:8088
                                window.location.port;       // => 8088
                                window.location.pathname;   // => test.jsp
                                window.location.search;     // => ?gg=1
                                window.location.protocol;   // => http:
                                this.$route.query
                                */

                                _this.setBase({ "curPath": window.location.pathname });
                                _this.setBase({ "curQs": window.location.search });
                                _this.setBase({ "curQsMap": _this.$GetQueryMap() });

                                _this.$PrintLog("user head curQsMap : ");
                                _this.$PrintLog(_this.getBase.curQs);
                            }
                            
                            // 3. 조회
                            {
                                // URL 설정
                                url = "/vue_api/common/menu/user_check_grade";

                                // data 설정
                                data["url"] = _this.getBase.curPath; // 현재 url 경로
                                data["qs"] = _this.getBase.curQs;    // 현재 url 쿼리스트링
                            }                            
                        }
                        break;

                    default:
                        {

                        };
                }

                // API 조회
                _this.$SendPost(url, data, _this.execReturn);
            }

            // 리턴 데이터
            , execReturn: function (data, err) {

                // this
                let _this = this;

                switch (data.GUBUN_PROC) {

                    case "INIT":
                        {
                            _this.$PrintLog("[[ HEAD ]]-------------------------------");
                            _this.$PrintLog(data);
                            _this.$PrintLog("[[ //HEAD ]]-------------------------------");

                            // 1. 기존 유저 정보와 비교해서 다르면 메뉴 초기화
                            if (_this.getBase.userNo != data.USER_NO
                                || _this.getBase.userGrade != data.USER_GRADE) {

                                _this.setBase({ "mapUserMenu": [] });
                            }

                            // 2. 유저 정보 새로 설정
                            _this.setBase({ "userLoginYn": data.USER_LOGIN_YN });
                            _this.setBase({ "userNo": data.USER_NO });
                            _this.setBase({ "userGrade": data.USER_GRADE });
                        }
                        break;

                    default:
                        {

                        };
                }
            }
        },

        beforeCreate() {
            this.$PrintLog(this.gubunPage + " : beforeCreate");
        },

        created() {
            this.$PrintLog(this.gubunPage + " : created");
            this.default();
        },

        beforeMount() {
            this.$PrintLog(this.gubunPage + " : beforeMount");            
        },

        mounted() {
            this.$PrintLog(this.gubunPage + " : mounted");
                        
            let _this = this;

            // 함수를 별도 변수로 분리 (나중에 제거하기 위함)
            this.bfCacheHandler = function (event) {
                // event.persisted: BFCache로부터 복원됨
                // navigation.type === 2: 뒤로가기/앞으로가기로 이동함
                if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
                    _this.$PrintLog("뒤로가기 감지 - 권한 체크 재실행");
                    _this.default();
                }
            };

            window.addEventListener('pageshow', this.bfCacheHandler);
        },

        beforeUpdate() {
            this.$PrintLog(this.gubunPage + " : beforeUpdate");
        },

        updated() {
            this.$PrintLog(this.gubunPage + " : updated");
        },

        beforeDestroy() {
            this.$PrintLog(this.gubunPage + " : beforeDestroy");

            // [중요] 컴포넌트가 파괴될 때 이벤트 리스너를 제거하여 메모리 누수 방지
            if (this.bfCacheHandler) {
                window.removeEventListener('pageshow', this.bfCacheHandler);
            }
        },

        destroyed() {
            this.$PrintLog(this.gubunPage + " : destroyed");
        },
    };
</script>
